import { render, staticRenderFns } from "./SuccessionPlanning.vue?vue&type=template&id=0b69dba0"
import script from "./SuccessionPlanning.vue?vue&type=script&lang=js"
export * from "./SuccessionPlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports